import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

export async function getAdminStudents(params = {}) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/students`, {
        params,
        headers,
    });
    return data;
}

export async function getAdminStudent(uid) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/students/${uid}`, {
        headers,
    });
    return data;
}

// Milestone 2: profile edit (coordinator+ only server-side; this call will
// simply fail with a 403 for a viewer-role admin).
export async function updateAdminStudent(uid, fields) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.put(`${host}/students/${uid}`, fields, {
        headers,
    });
    return data;
}

// Milestone 2: activate/deactivate. `status` is the numeric USER_STATUS code.
export async function updateAdminStudentStatus(uid, status) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.patch(`${host}/students/${uid}/status`, { status }, {
        headers,
    });
    return data;
}
